import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import { PostData } from '../../services/loginServics';
import { Redirect } from 'react-router-dom'
const styles = ({
    loginBox: {
        textAlign: 'center',
        width: '400px',
        height: '400px',
        position: 'absolute', /*it can be fixed too*/
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto',
        maxwidth: '100%',
        maxheight: '100%',
        flexDirection: 'column',
    },
    logindiv: {
        width: "100%",
        height: "100%",
        backgroundColor: '#064E5D',
        position: 'fixed',

    },
    inputdiv: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 110,
        padding: 20,
    }
});

class Login extends Component {
    constructor(props) {
        super(props)

        this.state = {
            username: '',
            password: '',
            redirectToReferrer: false

        };
        this.login = this.login.bind(this);
        this.handleChange = this.handleChange.bind(this)
    };
    login() {
        console.log(this.state);

        if (this.state.username && this.state.password) {
            PostData(this.state).then((result) => {
                console.log(result);
                let responseJson = result;
                if (responseJson.userData) {
                    sessionStorage.setItem('userData', JSON.stringify(responseJson));
                    this.setState({ redirectToReferrer: true });
                }
            });
        }
    }
    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {

        if (this.state.redirectToReferrer || sessionStorage.getItem('userData')) {
            return (<Redirect to={'/position'} />)
        }



        const { classes } = this.props;
        return (
            <div className={classes.logindiv}>
                <div className={classes.loginBox}>
                    <div className={classes.inputdiv}>
                        <input style={{
                            padding: 10,
                            marginTop: '8px',
                            backgroundColor: 'rgb(6, 51, 51)',
                            // borderRadius: 30,
                            color: '#FFF',
                            border: 'none',

                        }}
                            onChange={this.handleChange}
                            name="username"
                            placeholder="username"
                            margin="normal"
                        />
                        <input style={{
                            padding: 10,
                            marginTop: '8px',
                            backgroundColor: 'rgb(6, 51, 51)',
                            color: '#FFF',
                            // borderRadius: 30,
                            border: 'none',
                        }}
                            onChange={this.handleChange}
                            name="password"
                            placeholder="Password"
                            margin="normal"
                        />
                    </div>
                    <div style={{ marginLeft: 20, marginRight: 20 }}>

                        <Button style={{ backgroundColor: 'rgb(37, 201, 160)', color: '#FFF' }} onClick={this.login} fullWidth={true} variant="outlined" size="medium" color="primary">
                            Login
                    </Button>
                    </div>


                </div>
            </div>
        );
    }
}

Login.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);
